module.exports = __webpack_public_path__ + "img/79.650ab1a6.jpg";